import * as React from "react";
import { unicon } from "../../../common";

export default unicon(
  <path d="M3.706 15.634A1 1 0 105.072 16a1 1 0 00-1.366-.366zm1-9A1 1 0 105.072 8a1 1 0 00-.366-1.366zM4 12a1 1 0 10-1 1 1 1 0 001-1zm16.294-3.634A1 1 0 1018.928 8a1 1 0 001.366.366zM8 18.928a1 1 0 10.366 1.366A1 1 0 008 18.928zM12 2a1 1 0 101 1 1 1 0 00-1-1zm0 18a1 1 0 101 1 1 1 0 00-1-1zm8.294-4.366A1 1 0 1020.66 17a1 1 0 00-.366-1.366zM21 11a1 1 0 101 1 1 1 0 00-1-1zm-4-7.66a1 1 0 10.366 1.366A1 1 0 0017 3.34zm-1 15.588a1 1 0 101.366.366A1 1 0 0016 18.928z" />
);
